import { useEffect, useState } from "react";

function diff(target) {
    const now = Date.now();
    const t = new Date(target).getTime();
    let ms = Math.max(0, t - now);
    const days = Math.floor(ms / 86400000); ms -= days * 86400000;
    const hours = Math.floor(ms / 3600000); ms -= hours * 3600000;
    const minutes = Math.floor(ms / 60000); ms -= minutes * 60000;
    const seconds = Math.floor(ms / 1000);
    return { days, hours, minutes, seconds };
}

export default function CountdownTimer({ target, testId = "countdown" }) {
    const [t, setT] = useState(() => diff(target));
    useEffect(() => {
        const i = setInterval(() => setT(diff(target)), 1000);
        return () => clearInterval(i);
    }, [target]);

    const parts = [
        { label: "Days", value: t.days },
        { label: "Hours", value: t.hours },
        { label: "Min", value: t.minutes },
        { label: "Sec", value: t.seconds },
    ];

    return (
        <div data-testid={testId} className="flex items-center gap-2">
            {parts.map((p) => (
                <div key={p.label} className="flex flex-col items-center min-w-[54px] px-2 py-2 rounded-lg bg-white/5 border border-white/10 backdrop-blur-md">
                    <span className="font-display font-bold text-xl text-[#FFD400] tabular-nums">
                        {String(p.value).padStart(2, "0")}
                    </span>
                    <span className="text-[9px] uppercase tracking-widest text-white/50 mt-0.5">{p.label}</span>
                </div>
            ))}
        </div>
    );
}
